import { cn } from "@/lib/utils";
import { getLevelColor, formatLevel } from "@/lib/skillLevels";

interface SkillBadgeProps {
  level: number;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function SkillBadge({ level, size = "md", className }: SkillBadgeProps) {
  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-2.5 py-1",
    lg: "text-base px-3 py-1.5",
  };

  const displayLevel = level;

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-full font-bold text-white",
        getLevelColor(displayLevel),
        sizeClasses[size],
        className
      )}
      data-testid={`badge-skill-level-${Math.floor(displayLevel)}`}
    >
      Nivel {formatLevel(displayLevel)}
    </span>
  );
}
